module.exports = __webpack_public_path__ + "img/drawing.00dc5512.svg";